<template>
  <figure v-on:click="$emit('click')" class="image is-square poly-shadow poly-rounded">
    <img
      v-bind:src="album(0).cover.url2x"
      v-bind:srcset="`${album(0).cover.url}, ${album(0).cover.url2x} 2x, ${album(0).cover.url3x} 3x`"
      loading="lazy"
      style="padding-top: 2%; padding-left: 2%;"
    />
    <img
      v-bind:src="album(1).cover.url2x"
      v-bind:srcset="`${album(1).cover.url}, ${album(1).cover.url2x} 2x, ${album(1).cover.url3x} 3x`"
      loading="lazy"
      style="left: 50%; padding-right: 2%; padding-top: 2%;"
    />
    <img
      v-bind:src="album(2).cover.url2x"
      v-bind:srcset="`${album(2).cover.url}, ${album(2).cover.url2x} 2x, ${album(2).cover.url3x} 3x`"
      loading="lazy"
      style="top: 50%; padding-left: 2%; padding-bottom: 2%;"
    />
    <img
      v-bind:src="album(3).cover.url2x"
      v-bind:srcset="`${album(3).cover.url}, ${album(3).cover.url2x} 2x, ${album(3).cover.url3x} 3x`"
      loading="lazy"
      style="top: 50%; left: 50%; padding-right: 2%; padding-bottom: 2%;"
    />
    <slot/>
  </figure>
</template>

<script>
  export default {
    name: 'MultiAlbumCover',
    props: {
      albums: {
        type: Array,
        required: true
      }
    },
    methods: {
      album: function (albumNumber) {
        if (this.albums[albumNumber]) {
          return this.albums[albumNumber]
        } else {
          const albumPlaceholder = require('../assets/images/album_placeholder.png')

          return {
            cover: {
              url: albumPlaceholder,
              url2x: albumPlaceholder,
              url3x: albumPlaceholder
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  img {
    width: 50% !important;
    height: 50% !important;
    padding: 1%;
    border-radius: 0.6rem;
  }
</style>
